let tr = [];
let list = [];
let lang = 'en';

function bindData() {
  if (window.partner_resource_vue) {
    list = window.partner_resource_vue.list;
    tr = window.partner_resource_vue.tr;
    lang = window.partner_resource_vue.lang;
  }
}
bindData();
export {
  lang,
  list,
  tr
};



// WEBPACK FOOTER //
// ./App/components/PartnerResources/handler.js